var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg-sprite-9b09342188fefb54b61fd0b9946ff0fc.svg#icon-down-arrow-4971f';
                    var viewUrl = 'svg-sprite-9b09342188fefb54b61fd0b9946ff0fc.svg#view-icon-down-arrow-4971f';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };